'use strict';

/**
 * Uses google maps api to render a map
 */
function maps() {
    var map;
    var infowindow = new google.maps.InfoWindow();
    var markerImageUrl = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA0xpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6Mzc5QzA5NDg4NUU5MTFFOUFBRUVDQjcyMjAxNkE0MDciIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6Mzc5QzA5NDc4NUU5MTFFOUFBRUVDQjcyMjAxNkE0MDciIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0iYWRvYmU6ZG9jaWQ6cGhvdG9zaG9wOmU4YWYxMDgxLThlZDEtY2M0Mi05NjA4LWQ2MDQxOTBkNTM1OSIgc3RSZWY6ZG9jdW1lbnRJRD0iYWRvYmU6ZG9jaWQ6cGhvdG9zaG9wOmU4YWYxMDgxLThlZDEtY2M0Mi05NjA4LWQ2MDQxOTBkNTM1OSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pms2c48AAAJSSURBVHjazJgxSBtRGMdfrq1QRCktzY1JCAlkaYjJVAImg0haHfVSKEJxCDi3g9RNCnXRpUulS4dCBAkZKpi0QxaFTBpXE5pCS7GgQkNNSbHPL3BZrN77vrv3LvnDb7t8/O7x8t33noc5ywQwCYwBfuAu4AFOgSawB3wCtoF/zKXcApaABsCRfAWWgWHVcrPAF4LYZb4Dc6rkXjsQu8wb2XLvJMr12JQlt6JArsdbp3KPFMr1MOzKddvFiQuCbWDkOokbFoKLwBT2bXRdZ/F4nAUCAdbpdFir1cL+9Kbp8Zm6gseYFYhEIjyfz/N2u817AUFeKBR4LBbDruIvUxSdcUzhTCbDRclms1jJGYrgmqigz+fj2HRXGSH4gSK4IypYLBbRgtVqFSN4QBH8ZlXM6/Vyavx+v0jwx1Ui2jWCo1b20WiU3LPC4bDokWGKoGZVSdM0elP1eDB9Fy1yZlWpVquRBev1uuiRP5R6NdGmLpVK6P0HL4T5kxxSBN+LCoZCIbQgsmFvUQQfY5qrYRhCuVwuh23Uz6jb5hRTOJFI8HK5/J9YpVLhyWQSK/cbGKIKPqdMJTAk8FQqxdPpNA8Gg9SJ5pXdkeunC+NWd1C4bVdw2gXBp06n6i2FcrsyziR3gHNFgrqsg5OhQG5B9tHzo0S5HRUH9yHzG+1U7i9wT9XtQkaC4BPV9zPrDuQ23LrhatqQOzFvxlzJAxuCD5nLeUmQW2V9yj5CrsH6mPsIwTDrc+Yt5F6wAcm2W18Luxm94iujswFLyrwkPzLnSCm5EGAA2WvHW+a64dMAAAAASUVORK5CYII=';

    // Init EU Map in the center of the viewport
    var latlng = new google.maps.LatLng(50.508635, 3.8488281);
    var mapOptions = {
        scrollwheel: false,
        zoom: 4,
        maxZoom: 17,
        center: latlng,
        mapTypeId: google.maps.MapTypeId.ROADMAP
    };

    map = new google.maps.Map($('.map-canvas')[0], mapOptions);
    var mapdiv = $('.map-canvas').attr('data-locations');

    mapdiv = JSON.parse(mapdiv);

    var bounds = new google.maps.LatLngBounds();

    var item = mapdiv[0];
    var storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
    var marker = new google.maps.Marker({
        position: storeLocation,
        map: map,
        title: item.name,
        icon: markerImageUrl
    });

    marker.addListener('click', function () {
        infowindow.setOptions({
            content: item.infoWindowHtml
        });
        infowindow.open(map, marker);
    });

    // Create a minimum bound based on a set of storeLocations
    bounds.extend(marker.position);

    // Fit the all the store marks in the center of a minimum bounds when any store has been found.
    if (mapdiv && mapdiv.length !== 0) {
        map.fitBounds(bounds);
    }
}

module.exports = {
    init: function () {
        if ($('.map-canvas').data('has-google-api')) {
            maps();
        } else {
            $('.store-locator-no-apiKey').show();
        }
    },
    routeDescription: function () {
        // clicking on routedescription
        $('.route-button').on('click', function () {
            $.spinner().start();
            if (!navigator.geolocation) {
                $.spinner().stop();
                return;
            }

            navigator.geolocation.getCurrentPosition(function (position) {
                var storeObject = $('.store-detail').data('store');
                var url = 'https://www.google.be/maps/dir/' + position.coords.latitude + ',' + position.coords.longitude + '/' + storeObject.address1 + '+' + storeObject.postalCode + '+' + storeObject.city;
                var win = window.open(url);
                if (win) {
                    win.focus();
                } else {
                    // message popup has been blocked
                }
                $.spinner().stop();
            }, function () {
                var storeObject = $('.store-detail').data('store');
                var url = 'https://www.google.be/maps/search/?api=1&query=' + storeObject.address1 + '+' + storeObject.postalCode + '+' + storeObject.city;
                var win = window.open(url);
                if (win) {
                    win.focus();
                } else {
                    // message popup has been blocked
                }
                $.spinner().stop();
            });
        });
    }
};
